import { useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'src/store/react';
import {
  addHiddenJob,
  clearHiddenJobs,
  removeHiddenJob,
} from 'src/store/results';
import { selectHiddenJobs } from 'src/store/results/selectors';

export const useHiddenJobsHomeRecs = (jobId: string) => {
  const hiddenJobs = useSelector(selectHiddenJobs);
  const dispatch = useDispatch();

  const hideJob = useCallback(() => {
    dispatch(addHiddenJob(jobId));
  }, [dispatch, jobId]);

  const unhideJob = useCallback(() => {
    dispatch(removeHiddenJob(jobId));
  }, [dispatch, jobId]);

  const isJobHidden = useMemo(
    () => hiddenJobs.includes(jobId),
    [hiddenJobs, jobId],
  );

  return {
    isJobHidden,
    hideJob,
    unhideJob,
  };
};

export const useClearHiddenJobs = () => {
  const dispatch = useDispatch();

  const clearHiddenJobsFromStore = useCallback(() => {
    dispatch(clearHiddenJobs());
  }, [dispatch]);

  return clearHiddenJobsFromStore;
};
